module.exports = __webpack_public_path__ + "img/book.ead10bf7.svg";